<card class="audit">
    <div right-header-content class="filters"></div>
    <div card-body>
        <lsq-data-table
            *ngIf="!!tableDataSource"
            [dataSource]="tableDataSource"
            [layoutFixed]="true"
            [hasHeader]="true"
        >
            <lsq-column
                [column]="{
                    header: 'Date',
                    key: 'createdAt',
                    width: '20%',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    <span class="light-font">
                        <lsq-smart-truncate
                            class="file-field submitted-date"
                            [value]="row.createdAt | date: dateFormat.LongTime"
                        ></lsq-smart-truncate>
                    </span>
                </ng-template>
            </lsq-column>
            <lsq-column
                [column]="{
                    header: 'User',
                    key: 'createdBy',
                    width: '25%',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    <span class="light-font">
                        <lsq-smart-truncate [value]="row.createdBy ?? '---'"></lsq-smart-truncate>
                    </span>
                </ng-template>
            </lsq-column>
            <lsq-column
                [column]="{
                    header: 'Operation',
                    key: 'operationName',
                    width: '15%',
                    sortable: false
                }"
            >
            </lsq-column>
            <lsq-column
                [column]="{
                    header: 'Summary',
                    key: 'summary',
                    width: '40%',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    <span class="light-font">
                        <lsq-smart-truncate [value]="row.summary ?? '---'"></lsq-smart-truncate>
                    </span>
                </ng-template>
            </lsq-column>
        </lsq-data-table>
    </div>
</card>
